export const initialDashboard = {
  categories: [
    {
      id: "cspm",
      name: "CSPM Executive Dashboard",
      widgets: [
        {
          id: "w1",
          name: "Cloud Accounts",
          text: "Connected (2) · Not Connected (2) · Total: 4"
        },
        {
          id: "w2",
          name: "Cloud Account Risk Assessment",
          text: "Failed (1689) · Warning (681) · Not Available (36) · Passed (7253) · Total: 9659"
        }
      ]
    },
    {
      id: "cwpp",
      name: "CWPP Dashboard",
      widgets: [
        {
          id: "w3",
          name: "Top 5 Namespace Specific Alerts",
          text: "No Graph data available!"
        },
        {
          id: "w4",
          name: "Workload Alerts",
          text: "No Graph data available!"
        }
      ]
    },
    {
      id: "registry",
      name: "Registry Scan",
      widgets: [
        {
          id: "w5",
          name: "Image Risk Assessment",
          text: "1470 Total Vulnerabilities · Critical (9) · High (150)"
        },
        {
          id: "w6",
          name: "Image Security Issues",
          text: "2 Total Images · Critical (2) · High (2)"
        }
      ]
    }
  ]
};
